import { render, staticRenderFns } from "./TransferOrder.vue?vue&type=template&id=81b28d7c"
import script from "./TransferOrder.vue?vue&type=script&lang=js"
export * from "./TransferOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports